import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ClientsStore from '../../stores/ClientsStore'
import { Button, Grid, GridColumn, Header, Icon } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import AddressEquipment from './AddressEquipment'

class AddressInspection extends Component {
  static propTypes = {
    clientsStore: PropTypes.instanceOf(ClientsStore),
    canEdit: PropTypes.bool,
    // eslint-disable-next-line react/no-unused-prop-types
    canSendEmailLogin: PropTypes.bool
  }

  render () {
    const { clientsStore, canEdit } = this.props
    return (
      <>
        <Grid columns='equal' padded='vertically'>
          <Grid.Row>
            <GridColumn>
              <Header as='h2' floated='left'>
                Lieux d'inspections
              </Header>
            </GridColumn>
            <GridColumn>
              {canEdit &&
                <Button
                  as={Link} floated='right' icon primary
                  to={`/clients/inspections-addresses/create/${clientsStore.client.id}`}
                >
                  <Icon name='plus' />
                  Ajouter une adresse
                </Button>}
            </GridColumn>
          </Grid.Row>
          {clientsStore.client.clients_addresses.map(clientAddress => {
            return (<AddressEquipment key={clientAddress.id} clientId={clientsStore.client.id} clientAddress={clientAddress} canEdit={canEdit} />)
          })}
        </Grid>
      </>
    )
  }
}

export default AddressInspection
